const isNumericLike = (value) => {
  if (value === null || value === undefined || value === "") return true;
  if (typeof value === "number") return Number.isFinite(value);
  if (typeof value === "string") {
    const normalized = value.trim().replace(/,/g, "");
    return normalized === "" || /^-?\d+(\.\d+)?$/.test(normalized);
  }
  return false;
};

export const isTotalsTable = (tableData, mainColumns = []) => {
  if (!Array.isArray(tableData) || tableData.length !== 1) return false;
  const row = tableData[0];
  if (!row || typeof row !== "object") return false;

  const keys = Object.keys(row);
  if (keys.length === 0) return false;

  if (Array.isArray(mainColumns) && mainColumns.length > 0) {
    const mainColumnSet = new Set(mainColumns);
    const overlappingKeys = keys.filter((key) => mainColumnSet.has(key));
    // Treat as totals when there is meaningful overlap with visible/main columns.
    // Some APIs include extra summary fields that are not shown as table columns.
    if (overlappingKeys.length === 0) return false;
  }

  const numericLikeCount = keys.filter((key) => isNumericLike(row[key])).length;
  return numericLikeCount / keys.length >= 0.7;
};

const formatTotalValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "number") return value.toLocaleString("en-IN", { maximumFractionDigits: 3 });
  if (typeof value === "string") {
    const normalized = value.trim().replace(/,/g, "");
    if (/^-?\d+(\.\d+)?$/.test(normalized)) {
      return Number(normalized).toLocaleString("en-IN", { maximumFractionDigits: 3 });
    }
  }
  return String(value);
};

export const getTotalsEntries = (totalsTable, orderedColumns, displayNameMap = {}) => {
  if (!Array.isArray(totalsTable) || totalsTable.length === 0) return [];
  const totalRow = totalsTable[0];
  if (!totalRow || typeof totalRow !== "object") return [];

  const columnSet = new Set(orderedColumns || []);
  const keys = Object.keys(totalRow).filter((key) => columnSet.has(key));

  return keys.map((key) => ({
    key,
    label: displayNameMap[key] || key.replace(/_/g, " "),
    value: formatTotalValue(totalRow[key]),
  }));
};

export const getTotalsByColumn = (totalsTable, orderedColumns = []) => {
  if (!Array.isArray(totalsTable) || totalsTable.length === 0) return {};
  const totalRow = totalsTable[0];
  if (!totalRow || typeof totalRow !== "object") return {};

  const columnSet = new Set(orderedColumns || []);
  return Object.keys(totalRow)
    .filter((key) => columnSet.has(key))
    .reduce((acc, key) => {
      acc[key] = formatTotalValue(totalRow[key]);
      return acc;
    }, {});
};
